import { render, staticRenderFns } from "./reportFeeDetailRoom.vue?vue&type=template&id=c4f58842&scoped=true"
import script from "./reportFeeDetailRoom.vue?vue&type=script&lang=js"
export * from "./reportFeeDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./reportFeeDetailRoom.vue?vue&type=style&index=0&id=c4f58842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f58842",
  null
  
)

export default component.exports